import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { NativeSelect, NativeSelectOption } from '@/components/ui/native-select'

interface InspectionFilterOption {
	value: string
	label: string
	count?: number
}

interface InspectionFilterSelect {
	id: string
	label: string
	value?: string
	onChange: (value: string) => void
	options: InspectionFilterOption[]
	allLabel?: string
}

interface InspectionListFiltersProps {
	searchValue: string
	onSearchChange: (value: string) => void
	selects: InspectionFilterSelect[]
}

export const InspectionListFilters = ({
	searchValue,
	onSearchChange,
	selects,
}: InspectionListFiltersProps) => {
	const { t } = useTranslation()

	return (
		<div className="mb-4 space-y-3">
			<div className="w-full">
				<label
					className="mb-2 block text-sm font-medium text-kaefer-dark-grey"
					htmlFor="inspection-list-search"
				>
					{t('common.search')}
				</label>
				<Input
					id="inspection-list-search"
					value={searchValue}
					onChange={(event) => onSearchChange(event.target.value)}
					placeholder={t('common.search')}
				/>
			</div>

			<div className="flex flex-col gap-3 lg:flex-row lg:flex-wrap">
				{selects
					.filter(
						(select) => select.options.length > 0 || Boolean(select.value),
					)
					.map((select) => (
						<div key={select.id} className="w-full lg:flex-1 lg:min-w-[320px]">
							<div className="mb-2 flex items-center gap-2">
								<label
									className="text-sm font-medium text-kaefer-dark-grey"
									htmlFor={select.id}
								>
									{select.label}
								</label>
							</div>

							<NativeSelect
								id={select.id}
								value={select.value ?? ''}
								onChange={(event) => select.onChange(event.target.value)}
								className="w-full"
							>
								{select.allLabel ? (
									<NativeSelectOption value="">
										{select.allLabel}
									</NativeSelectOption>
								) : null}

								{select.options.map((option) => (
									<NativeSelectOption key={option.value} value={option.value}>
										{option.label}
										{typeof option.count === 'number'
											? ` (${option.count})`
											: ''}
									</NativeSelectOption>
								))}
							</NativeSelect>
						</div>
					))}
			</div>
		</div>
	)
}
